/*
 * @轮子的作者: 轮子哥
 * @Date: 2023-12-25 09:04:55
 * @LastEditTime: 2024-01-08 14:31:48
 */
/**
 * 公共配置文件
 */
module.exports = {
    environment: "build",                      //打包部署服务器的时候，请把environment换成build
    apiUrl: "https://www.yhdd.org",            // 与 Nginx 同域 HTTPS，不再使用 :3030
    aesKey: "我们只生产轮子，不是轮子的搬运工",
    aesIv: "我家门前有两个轮子，一个是轮子，另一个也是轮子"
}
